var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEnlarge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    transform: "matrix(-1 0 0 1 20 0)",
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2038_4052",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2038_4052",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAABwElEQVR4nO3dMUoDQRSA4VzCgBfIHexylFTe4QXyXmfhDay8kwhWYq2XUF4nYtSETPZP/D+YamHZ4Wd2YTZsZjNJkiRJkiRJkkRSVYuquh48llPP82RU1aqq3keOzLyfep4nwyAwBoExCIxBTjhIZr5m5vOuo6pup57nuQZ5Wq/Xl1Nf81nb9ZZlFOAzxCjAh7pRjh/kraoefwnTx+ejru1f2hYkM18i4qKqHlwpkCB93CiwIM0osCDNKLAgzSiwIM0osCDNKLAgzSiwIM0osCDNKLAgzSiwIM0osCDNKAew2WyuMvPu66iqm33OV1Vzd4lhwl1injAKTxiFJ4zCE0bhCaPwhFF4wig8YRSeMApPGIUnjMITRuEJo/CEUXjCKDxhFJ4wCk8Nfh3cr6m/e33dr7UPP5szEQNXSv+QY8s5V2NmcyZiUBSDwKIYBBbFILAoBoFFMQgsikFgUQwCi2IQWBSDwKIYBBbFILAoBuHtEvcnqNxcpKyUH4a7vbAoBoFFMQgsikH+qj/KvM/HnPsj0AYZoP/6Ys8HtbesEQwCk64QljQISxqEpaqWR/gTs8XU85QkSZIkSZIkSbPPPgCUzAhgd9mjTAAAAABJRU5ErkJggg=="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnlarge);
export default __webpack_public_path__ + "static/media/Enlarge.31e41f1f23585bf2fd99d0ba5f23e3a6.svg";
export { ForwardRef as ReactComponent };